module.exports = __webpack_public_path__ + "static/img-hp-icon-pharm-teach-bffabf34236782478cfa4dc6241a700f.png";